import requestNewUser from './requestNewUser';

const watchRequestUser = [requestNewUser];

export default watchRequestUser;
